<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="war-room-post-content-story" data-test="war-room-post-content-story" v-html="text" />
</template>

<script>
export default {
  name: 'WarRoomPostContentStory',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
$embed-image: 'war-room-post-text__embed-image';

.war-room-post-content-story {
  color: var(--theme-color-text);
  overflow-wrap: break-word;

  ::v-deep .#{$embed-image} {
    max-width: 100%;

    &-delete-btn {
      display: none;
    }

    &-container {
      position: relative;
      background: var(--theme-color-over-card);

      @include flex-center;
    }
  }

  ::v-deep em {
    font-style: italic;
  }

  ::v-deep * {
    color: inherit;
  }

  ::v-deep a {
    color: var(--blue-50);
    text-decoration: underline;
  }
}
</style>
